export default __webpack_public_path__ + "static/media/jobs_here_logo.dc389daf.png";